import { TransferTrip } from '@/helpers/transfer/transfer.interfaces';

export interface CheckoutState {
    step: string | null;
    states: CheckoutStepState[];
    clearSessionCart: boolean;
    transfer: CheckoutTransfer;
}

export enum CheckoutStepType {
    Contact = 'contact',
    Confirm = 'confirm',
    Travellers = 'travellers',
    ServicePackage = 'service_package',
    Addons = 'addons',
    Sembonus = 'sembonus',
    Product = 'product_',
}

export interface CheckoutStepState {
    id: CheckoutStepType;
    valid: boolean;
    touched: boolean;
    fields: CheckoutStepStateField[];
}

interface CheckoutTransfer {
    trips: TransferTrip[];
}

export interface CheckoutStepStateField {
    name: string;
    touched: boolean;
    value?: any;
}
